import { Subscription, ReplaySubject, Subject, Observable, fromEvent, of, } from 'rxjs';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild, AfterViewInit, Inject, ElementRef, Optional, OnChanges, SimpleChanges, } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
import Swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl, ValidatorFn, AbstractControl, ValidationErrors, AsyncValidatorFn, } from '@angular/forms';
import { emailPattern, noWhitespaceInRequiredValidator, mobilePattern, datePickerMinDate, convertToNgbDate, allowedBillFiles, allowedBillGPayFiles, allowedBillQRFiles, allowedFiles, allowedReferralFiles, medicine_supply_list, allowedQuotationFiles, allowedAdditionalFiles } from '../../shared/constants';
import { NgSelectModule } from '@ng-select/ng-select';
import { timer } from 'rxjs';
import { debounceTime, map, distinctUntilChanged, filter, take, takeUntil, switchMap, catchError, } from 'rxjs/operators';
import { inject, TemplateRef, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';
import { addDays, isBefore, isSameDay } from 'date-fns';
import { CaseDetailsComponent } from '../case-details/case-details.component';
import { NavbarComponent } from '../../navbar/navbar.component';

@Component({
	selector: 'app-followup-details',
	templateUrl: './followup-details.component.html',
	styleUrls: ['./../case-details/case-details.component.scss', './followup-details.component.scss'],
	animations: [
		trigger('fadeInOut', [
			state('void', style({
				opacity: 0
			})),
			transition(':enter, :leave', [
				animate(500)
			])
		])
	]
})
export class FollowupDetailsComponent implements OnChanges {
	@Input() uId: any = null;
	@Input() followupId: any = null;
	followUpDetails: any = null;
	newFollowupForm: FormGroup = this.formBuilder.group({
		new_follow_up_date: [null, [Validators.required]],
		new_visit_type_id: [null, [Validators.required]]
	});
	get f2() { return this.newFollowupForm.controls }
	flwupFormSubmitted = false;
	newFollowupLoader = false;
	customErrorNewFlwup: any = {};
	moduleForm: FormGroup = this.formBuilder.group({
		follow_up_date: [null, [Validators.required]],
		dropoff_hospital_id: [null],
		opd_doctor_id: [null],
		/* is_specialist_consulted: [false], */
		opd_notes: [null],
		lab_test: [null],
		follow_up_status_id: [null, [Validators.required]],
		visit_type_id: [null, [Validators.required]],
		/* physiotherapy_date: [null], */
		physiotherapy_percentage: [null, [Validators.pattern(/^[+-]?([0-9]*[.])?[0-9]+$/)]],
		physiotherapy_notes: [null],
		/* physiotherapy_end_date: [null],
		physiotherapy_session_counts: [null, [Validators.pattern(/^\d+$/)]], */
		hospitalization_status_id: [null],
		admission_date: [null],
		surgery_status_id: [null],
		actual_surgery_date: [null],
		actual_discharge_date: [null],
		is_ambulance_needed: [false],
		expected_days: [null, [Validators.pattern(/^[+-]?([0-9]*[.])?[0-9]+$/)]],
		/* disability_status_id: [null],
		disability_per: [null, [Validators.pattern(/^[+-]?([0-9]*[.])?[0-9]+$/)]],
		disability_notes: [null], */
		is_payment_needed: [false],
		travel_needed: [0],
		medical_prescription: [false],
		status3_id: [null, [Validators.required]],
		next_follow_up_date: [null],
		next_visit_type_id: [null],
		/* fitness_status_id: [null], */
		/* status4_id: [null],
		closure_notes: [null], */
		is_handover: [false],
		medicine_supply: [null],
		amount: [0, [Validators.pattern(/^[+-]?([0-9]*[.])?[0-9]+$/)]],
		is_referral_added: [false],
		referral_file: [null],
		followup_report_sent: [false],
	});
	get f() { return this.moduleForm.controls }
	showLoader = false;
	formSubmitted = false;
	customError: any = {};
	hospitalList: any[] = [];
	doctorList: any[] = [];
	pageLoading1 = false;
	pageLoading2 = false;
	pageLoading3 = false;
	pageLoading4 = false;
	pageLoading5 = false;
	showOPDFields = false;
	showIPDFields = false;
	showPhysiotherapyFields = false;
	showTeleConsultsFields = false;
	showNonMedicalFields = false;
	showReferralFields = false;
	labTestList: any[] = [];
	medicine_supply_list = medicine_supply_list;
	/* fitnessStatusList: any[] = []; */
	followUpBillsData: any[] = [];
	minDate = datePickerMinDate;
	billingMaxDate = convertToNgbDate(new Date());
	showClosureFields = false;
	showCompletedFields = false;
	showInProgressFields = false;
	File_Storage_URL = environment.File_Storage_URL;
	amount = 0;

	billingDetailsForEdit: any[] = [];
	saveBillLoader = false;
	billFileUploadLoader: any = null;

	followupFiles: any[] = [];
	followupFilesForEdit: any[] = [];
	followupAdditionalFiles: any[] = [];
	followupAdditionalFilesForEdit: any[] = [];
	quillConfig = {
		toolbar: {
			container: [
				['bold', 'italic', 'underline'],
			]
		}
	};
	/* apptDetailsPath = ""; */

	showAdmittedFields = false;
	showDayCareFields = false;
	showPreAdmittedFields = false;
	showDischargedFields = false;

	showSurgeryYesFields = false;
	showSurgeryNoFields = false;

	isFollowupClosed = false;
	isFollowupCompleted = false;
	follow_up_date_original: any = null;
	otpFormLoader = false;
	showOTP = false;
	otpFormSubmitted = false;
	otpForm: FormGroup = this.formBuilder.group({
		reason: [null, [Validators.required]],
		otp: [null]
	});
	get f1() { return this.otpForm.controls }
	customErrorOTP: any = {};
	otpMailId: any = "";
	/* followupCount = 1; */

	constructor(private toastr: ToastrService, private apiService: ApiService, public formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute, @Optional() @Inject(CaseDetailsComponent) public parent: CaseDetailsComponent, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) {
		this.apiService.getFollowUpFilesRefreshEvent().subscribe({
			next: (val) => {
				if (val) {
					this.getFollowUpFiles();
					this.getFollowUpAdditionalFiles();
				}
			}
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (
			changes &&
			changes.followupId &&
			changes.followupId.currentValue
		) {
			this.initComponent();
		}
	}

	public initComponent() {
		this.getDetails();
		this.getTreatmentCosts();
		this.getHospitalList();
		this.getLabTest();
		this.checkHandoverAfterClosed();
		/* this.getQuestions(); */
	}

	copyLoader: any = null;
	attDest: any = null;
	addMailAttachments(index: number, dest: string) {
		this.attDest = dest;
		let type: string = "";
		if (dest == "bill_file" || dest == "gpay") {
			type = "follow_up_bills";
		} else if (dest == "file") {
			type = "follow_up_files";
		} else if (dest == "additional_file") {
			type = "additional_follow_up_files";
		}
		const files = this.parent.selectedAttachments.map((att: any) => new URL(att.url).pathname.slice(1));
		const payload = { files: files, type: type };
		this.copyLoader = index;
		this.apiService.copyMailFilesToBilling(payload).subscribe({
			next: (data: any) => {
				if (dest == "bill_file") {
					if (!this.billingDetailsForEdit[index].files) {
						this.billingDetailsForEdit[index].files = [];
					}
					for (let i = 0; i < data.length; i++) {
						this.billingDetailsForEdit[index].files.push(data[i]);
					}
				} else if (dest == "gpay") {
					if (!this.billingDetailsForEdit[index].gpay_files) {
						this.billingDetailsForEdit[index].gpay_files = [];
					}
					for (let i = 0; i < data.length; i++) {
						this.billingDetailsForEdit[index].gpay_files.push(data[i]);
					}
				} else if (dest == "file") {
					if (!this.followupFilesForEdit[index].file_url) {
						this.followupFilesForEdit[index].file_url = [];
					}
					for (let i = 0; i < data.length; i++) {
						this.followupFilesForEdit[index].file_url.push(data[i]);
					}
				} else if (dest == "additional_file") {
					if (!this.followupAdditionalFilesForEdit[index].file_url) {
						this.followupAdditionalFilesForEdit[index].file_url = [];
					}
					for (let i = 0; i < data.length; i++) {
						this.followupAdditionalFilesForEdit[index].file_url.push(data[i]);
					}
				}
				this.copyLoader = null;
				this.attDest = null;
				this.toastr.success('Files added successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.parent.clearSelectedAttachments();
				/* this.parent.updateMailAttachments(); */
			}, error: (error) => {
				this.copyLoader = null;
				this.attDest = null;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	disableBillFileAtt(index: number) {
		return this.copyLoader == index && this.attDest == "bill_file";
	}

	disableBillGPayAtt(index: number) {
		return this.copyLoader == index && this.attDest == "gpay";
	}

	disableFileAtt(index: number) {
		return this.copyLoader == index && this.attDest == "file";
	}

	disableAdditionalFileAtt(index: number) {
		return this.copyLoader == index && this.attDest == "additional_file";
	}

	getDetails() {
		this.pageLoading1 = true;
		this.apiService.getFollowupDetails(this.followupId).subscribe({
			next: (data: any) => {
				this.pageLoading1 = false;
				this.followUpDetails = data.data;
				this.getFolloupBills();
				this.getFollowUpFiles();
				this.getFollowUpAdditionalFiles();
				this.f.follow_up_date.setValue(this.apiService.getDateFromDateString(this.followUpDetails.follow_up_date));
				this.f.dropoff_hospital_id.setValue(this.followUpDetails.dropoff_hospital?.id);
				this.f.opd_doctor_id.setValue(this.followUpDetails.opd_doctor?.id);
				this.f.follow_up_status_id.setValue(this.followUpDetails.follow_up_status?.id);
				this.f.visit_type_id.setValue(this.followUpDetails.visit_type?.id);
				/* this.f.is_specialist_consulted.setValue(this.followUpDetails.is_specialist_consulted); */
				this.f.is_payment_needed.setValue(this.followUpDetails.is_payment_needed);
				this.f.travel_needed.setValue(this.followUpDetails.travel_needed || 0);
				this.f.medical_prescription.setValue(this.followUpDetails.medical_prescription);
				this.f.opd_notes.setValue(this.followUpDetails.opd_notes);
				this.f.lab_test.setValue(this.followUpDetails.lab_test);
				/* this.f.physiotherapy_session_counts.setValue(this.followUpDetails.physiotherapy_session_counts); */
				this.f.physiotherapy_percentage.setValue(this.followUpDetails.physiotherapy_percentage);
				this.f.physiotherapy_notes.setValue(this.followUpDetails.physiotherapy_notes);
				/* this.f.physiotherapy_date.setValue(this.apiService.getDateFromDateString(this.followUpDetails.physiotherapy_date));
				this.f.physiotherapy_end_date.setValue(this.apiService.getDateFromDateString(this.followUpDetails.physiotherapy_end_date)); */
				this.f.hospitalization_status_id.setValue(this.followUpDetails.hospitalization_status);
				this.f.admission_date.setValue(this.apiService.getDateFromDateString(this.followUpDetails.admission_date));
				this.f.surgery_status_id.setValue(this.followUpDetails.surgery_status);
				this.f.actual_surgery_date.setValue(this.apiService.getDateFromDateString(this.followUpDetails.actual_surgery_date));
				this.f.actual_discharge_date.setValue(this.apiService.getDateFromDateString(this.followUpDetails.actual_discharge_date));
				this.f.is_ambulance_needed.setValue(this.followUpDetails.is_ambulance_needed);
				this.f.expected_days.setValue(this.followUpDetails.expected_days);
				/* this.f.disability_status_id.setValue(this.followUpDetails.disability_status);
				this.f.disability_per.setValue(this.followUpDetails.disability_per);
				this.f.disability_notes.setValue(this.followUpDetails.disability_notes); */
				this.f.status3_id.setValue(this.followUpDetails.status3);
				this.f.is_handover.setValue(this.followUpDetails.is_handover);
				this.f.medicine_supply.setValue(this.followUpDetails.medicine_supply || null);
				this.f.amount.setValue(this.followUpDetails.amount);
				this.f.is_referral_added.setValue(this.followUpDetails.is_referral_added);
				this.f.referral_file.setValue(this.followUpDetails.referral_file);
				this.f.followup_report_sent.setValue(this.followUpDetails.followup_report_sent);
				this.apptTypeChanged(false);
				this.reffFlagChanged();
				this.followupStatusChanged(false);
				this.hospitalizationChanged();
				this.surgeryChanged();
				this.follow_up_date_original = this.f.follow_up_date.value;
				if (this.f.follow_up_status_id.value == 2) {
					this.isFollowupCompleted = true;
					this.isFollowupClosed = false;
				} else if (this.f.follow_up_status_id.value == 3) {
					/* Closed status removed from follow-up so setting isFollowupCompleted  */
					/* this.isFollowupCompleted = true; */
					this.isFollowupCompleted = false;
					this.isFollowupClosed = true;
				} else {
					this.isFollowupCompleted = false;
					this.isFollowupClosed = false;
				}
				/* this.getDoctorList(); */
				this.apiService.doctorData$.subscribe((doctors: any) => {
					if (doctors) {
						this.getDoctorList();
					}
				})
				if (this.navbar.userAccess?.Follow_up != 'Full') {
					this.moduleForm.disable();
				}
				if (this.navbar.userAccess?.Follow_up_report != 'Full') {
					this.f.followup_report_sent.disable();
				}
				try {
					this.parent.autoReadyToBill();
				} catch (error) { }
			}, error: (error) => {
				this.pageLoading1 = false;
				this.followUpDetails = null;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	Questions: any[] = [];
	questionError: any = null;
	getQuestions() {
		this.showLoader = true;
		this.questionError = null;
		this.apiService.getQuestions({ id: atob(this.followupId) }).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				try {
					this.Questions = data.Questions.map((que: any) => {
						return {
							question: que.question,
							answer: que.answer || null,
							options: que.options
						}
					});
				} catch (error) {
					this.Questions = [];
				}
				$("#questionnaireModalFoll").modal("show");
				if (data.Icd_codes && data.Icd_codes.length && data.Icd_codes[0].ICD_Code) {
					this.confirmIcdCode(data.Icd_codes[0].ICD_Code);
				}
			}, error: (error) => {
				this.showLoader = false;
				this.Questions = [];
				this.gotoList();
				if (error.status == 400) {
					this.questionError = error.error;
				} else {
					this.toastr.error('Something went wrong', 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				}
			}
		});
	}

	savingQuestionnaire = false;
	saveQuestions() {
		let questions = this.Questions.map((que: any) => {
			return {
				question: que.question,
				answer: que.answer || null,
				options: que.options
			}
		});
		let payload = {
			id: this.followUpDetails.id,
			questions: questions
		}
		this.savingQuestionnaire = true;
		this.apiService.saveFollowupQuestions(payload).subscribe({
			next: (data: any) => {
				this.savingQuestionnaire = false;
				this.toastr.success('Saved successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				$("#questionnaireModalFoll").modal("hide");
				this.gotoList();
			}, error: (error) => {
				this.savingQuestionnaire = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	confirmIcdCode(ICD_Code: any) {
		Swal.fire({
			title: 'ICD code was found',
			html: 'ICD code <strong>' + ICD_Code + '</strong> was found. Would you like to save it?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'No'
		}).then((result) => {
			if (result.value) {
				const payload = {
					"id": this.uId,
					"icd_code": ICD_Code
				};
				this.apiService.updateCaseDetails(payload).subscribe({
					next: (data: any) => {
						this.toastr.success('Saved successfully', 'Success', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
						this.parent.caseDetails.icd_code = ICD_Code;
					}, error: (error) => {
						this.toastr.error('Something went wrong', 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		})
	}

	removeQuestion(index: number) {
		this.Questions.splice(index, 1);
		this.formChanged();
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	isRequired(field: string) {
		return this.f[field].hasValidator(Validators.required);
	}

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) {
				}
			}
		});
		this.customError = {};
	}

	getPrevFollowupDate() {
		let count = this.parent.followupList.length;
		let prevFollowupDate = null;
		for (let i = 0; i < count; i++) {
			if (this.parent.followupList[i].enc_id == this.followupId && i < count - 1) {
				prevFollowupDate = this.parent.followupList[i + 1].follow_up_date;
			}
		}
		return prevFollowupDate;
	}

	saveFollowUp_A() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required fields", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		if (!this.apiService.getDateStringFromDate(this.f.follow_up_date?.value)) {
			this.toastr.info("Follow-up date cannot be blank", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		if (
			/* this.followupCount == 1 &&  */isBefore(this.f.follow_up_date.value, this.apiService.getDateFromDateString(this.parent.caseDetails.start_date))
		) {
			this.f.follow_up_date.setErrors({ incorrect: true });
			this.customError.follow_up_date = "Cannot be less than case start date";
			this.toastr.info("Followup date cannot be less than case start date", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		if (
			this.getPrevFollowupDate() && isBefore(this.f.follow_up_date.value, this.apiService.getDateFromDateString(this.getPrevFollowupDate()))
		) {
			this.f.follow_up_date.setErrors({ incorrect: true });
			this.customError.follow_up_date = "Cannot be less than previous followup date";
			this.toastr.info("Followup date cannot be less than previous followup date", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		if (
			this.showCompletedFields &&
			this.f.next_follow_up_date.value &&
			(
				isBefore(this.f.next_follow_up_date.value, this.f.follow_up_date.value) ||
				isSameDay(this.f.next_follow_up_date.value, this.f.follow_up_date.value)
			)
		) {
			this.f.next_follow_up_date.setErrors({ incorrect: true });
			this.customError.next_follow_up_date = "Should be greater than current followup date";
			return;
		}
		if (this.showClosureFields) {
			let msgList: string[] = [];
			if (this.parent.caseReminder?.crew_details_not_filled) {
				msgList.push("<li>Ensure all crew details are filled</li>");
			}
			if (this.parent.caseReminder?.data_not_filled) {
				msgList.push("<li>Ensure key evaluations are filled</li>");
			}
			if (this.parent.caseReminder?.files_not_uploaded.length) {
				msgList.push("<li>Upload all missing files under follow-ups</li>");
			}
			for (let i = 0; i < this.parent.followupList.length; i++) {
				if (
					this.parent.followupList[i].id != this.followUpDetails.id &&
					this.parent.followupList[i].follow_up_status?.id == 1
				) {
					msgList.push("<li>All other follow-ups are completed.</li>");
					break;
				}
			}
			if (msgList.length) {
				let str = '<p class="mb-0">To proceed and mark this follow-up as <strong>"Closed"</strong>, please ensure the following actions are completed';
				str += "<ol>"
				str += msgList.join("");
				str += "</ol>"
				Swal.fire({
					title: 'Incomplete details',
					html: str,
					icon: 'warning',
					customClass: { htmlContainer: "text-start" }
				});
				return;
			}
			/* Get records after current i.e. records which are before current followup in array */
			const result = this.takeWhile(this.parent.followupList, item => item.id != this.followUpDetails.id);
			let notLastFollowup = false;
			for (let i = 0; i < result.length; i++) {
				if (result[i].visit_type && result[i].visit_type.id != 5) {
					notLastFollowup = true;
				}
			}
			if (
				/* this.parent.followupList.length &&
				this.parent.followupList[0].id != this.followUpDetails.id */
				notLastFollowup
			) {
				Swal.fire({
					title: 'Error',
					html: 'Only last follow-up can be closed',
					icon: 'warning'
				});
				return;
			}
			for (let i = 0; i < this.parent.followupList.length; i++) {
				if (
					this.parent.followupList[i].id != this.followUpDetails.id &&
					this.parent.followupList[i].follow_up_status?.id == 3
				) {
					Swal.fire({
						title: 'Error',
						html: 'There can be only 1 follow-up with status "Closed" in a case',
						icon: 'warning'
					});
					return;
				}
			}
			this.parent.openCaseStatusModal();
			return;
		}
		/* if (
			this.showClosureFields &&
			this.parent.caseDetails.status == 1 &&
			this.parent.validateForCaseClosure().length
		) {
			this.parent.openCaseStatusModal();
			return;
		} */
		/* if (this.showClosureFields) {
			let isDataIncomplete = false;
			let msgList: string[] = [];
			for (let i = 0; i < this.parent.followupList.length; i++) {
				if (
					this.parent.followupList[i].id != this.followUpDetails.id &&
					this.parent.followupList[i].follow_up_status?.id == 1
				) {
					msgList.push("<li>All other follow-ups are completed.</li>");
					isDataIncomplete = true;
					break;
				}
			}
			if (this.parent.caseReminder.crew_details_not_filled) {
				msgList.push("<li>All crew details are filled</li>");
				isDataIncomplete = true;
			}
			if (this.parent.caseReminder.data_not_filled) {
				msgList.push("<li>Key evaluations are filled</li>");
				isDataIncomplete = true;
			}
			if (this.parent.caseReminder.incomplete_billing.length) {
				msgList.push("<li>Billing in all follow-ups is completed</li>");
				isDataIncomplete = true;
			}
			for (let i = 0; i < this.parent.followUpBillsData.length; i++) {
				if (!this.parent.followUpBillsData[i].is_approved) {
					msgList.push("<li>All bills are approved</li>");
					isDataIncomplete = true;
					break;
				}
			}
			if (this.parent.caseReminder.files_not_uploaded.length) {
				msgList.push("<li>Missing files are uploaded in follow-ups</li>");
				isDataIncomplete = true;
			}
			if (isDataIncomplete) {
				let str = '<p class="mb-0">Please make sure following details are completed to close the case</p>';
				str += "<ul>"
				str += msgList.join("");
				str += "</ul>"
				Swal.fire({
					title: 'Incomplete details',
					html: str,
					icon: 'warning',
					customClass: { htmlContainer: "text-start" }
				});
				return;
			}
		} */
		if (this.isFollowupClosed || this.isFollowupCompleted) {
			if (isSameDay(this.follow_up_date_original, this.f.follow_up_date.value)) {
				this.saveFollowUp_B();
			} else {
				this.otpVerification();
			}
		} else {
			this.saveFollowUp_B();
		}
	}

	saveFollowUp_B() {
		/* let questions = this.Questions.map((que: any) => {
			return {
				question: que.question,
				answer: que.answer || null,
				options: que.options
			}
		}) */
		let payload1: any = {
			id: this.followupId,
			case_id_id: this.parent.caseDetails.id,
			follow_up_date: this.apiService.getDateStringFromDate(this.f.follow_up_date?.value) || null,
			dropoff_hospital_id: this.f.dropoff_hospital_id.value,
			opd_doctor_id: this.f.opd_doctor_id.value,
			follow_up_status_id: this.f.follow_up_status_id.value,
			visit_type_id: this.f.visit_type_id.value,
			/* is_specialist_consulted: this.f.is_specialist_consulted.value, */
			is_payment_needed: this.f.is_payment_needed.value,
			travel_needed: this.f.travel_needed.value,
			medical_prescription: this.f.medical_prescription.value,
			opd_notes: this.f.opd_notes.value,
			lab_test: this.f.lab_test.value,
			/* physiotherapy_session_counts: this.f.physiotherapy_session_counts.value, */
			physiotherapy_percentage: this.f.physiotherapy_percentage.value,
			physiotherapy_notes: this.f.physiotherapy_notes.value,
			/* physiotherapy_date: this.apiService.getDateStringFromDate(this.f.physiotherapy_date.value) || null,
			physiotherapy_end_date: this.apiService.getDateStringFromDate(this.f.physiotherapy_end_date.value) || null, */
			hospitalization_status_id: this.f.hospitalization_status_id.value,
			admission_date: this.apiService.getDateStringFromDate(this.f.admission_date.value) || null,
			surgery_status_id: this.f.surgery_status_id?.value,
			actual_surgery_date: this.apiService.getDateStringFromDate(this.f.actual_surgery_date.value) || null,
			actual_discharge_date: this.apiService.getDateStringFromDate(this.f.actual_discharge_date.value) || null,
			is_ambulance_needed: this.f.is_ambulance_needed.value,
			expected_days: this.f.expected_days.value,
			/* disability_status_id: this.f.disability_status_id.value,
			disability_per: this.f.disability_per.value,
			disability_notes: this.f.disability_notes.value, */
			status3_id: this.f.status3_id.value,
			is_handover: this.f.is_handover.value,
			medicine_supply: this.f.medicine_supply.value || 0,
			amount: this.f.amount.value,
			is_referral_added: this.f.is_referral_added.value,
			referral_file: this.f.referral_file.value,
			/* questions: questions */
		}
		this.showLoader = true;
		this.apiService.createUpdateFollowup(payload1).subscribe({
			next: (data: any) => {
				if (!this.showClosureFields && this.followUpDetails.follow_up_status?.id == 3) {
					/* Status changed from closed to In progress or completed so change case status to open  */
					this.apiService.updateCaseDetails({ id: this.uId, status_id: 1, status4_id: null, mark_for_closure: false/* , closure_notes: null */ }).subscribe({
						next: (data: any) => {
						}, error: (error) => {
						},
					});
				}
				/* if (this.showClosureFields) {
					///////This/////////
					this.parent.openCaseStatusModal();
					this.showLoader = false;
					this.toastr.success('Saved successfully', 'Success', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
					///////Or This/////////
					let payload2: any = {
						id: this.uId,
						closure_notes: this.f.closure_notes.value,
						status4_id: this.f.status4_id.value,
						status_id: 2,
					}
					this.apiService.updateCaseDetails(payload2).subscribe({
						next: (data: any) => {
							this.showLoader = false;
							this.toastr.success('Saved successfully', 'Success', {
								timeOut: 3000,
								tapToDismiss: true,
								closeButton: true
							});
							this.gotoList();
						}, error: (error) => {
							this.showLoader = false;
							this.toastr.error('Something went wrong', 'Error', {
								timeOut: 3000,
								tapToDismiss: true,
								closeButton: true
							});
						},
					});
				} else  */if (this.showCompletedFields && this.f.next_follow_up_date.value) {
					let visit_type = this.f.next_visit_type_id?.value;
					let is_payment_needed = false;
					if (visit_type == 1) {
						/* OPD */
						is_payment_needed = true;
					} else if (visit_type == 3) {
						/* Physiotherapy */
						is_payment_needed = true;
					} else if (visit_type == 4) {
						/* Tele-Consult */
						is_payment_needed = true;
					}
					let payload3: any = {
						case_id_id: this.parent.caseDetails.id,
						follow_up_date: this.apiService.getDateStringFromDate(this.f.next_follow_up_date?.value),
						visit_type_id: this.f.next_visit_type_id?.value,
						is_payment_needed: is_payment_needed
					}
					this.apiService.createUpdateFollowup(payload3).subscribe({
						next: (data: any) => {
							/* if (this.isFollowupClosed) {
								let payload4: any = {
									id: this.uId,
									closure_notes: null,
									status4_id: null,
									status_id: 1
								}
								this.apiService.updateCaseDetails(payload4).subscribe({
									next: (data: any) => {
										this.showLoader = false;
										this.toastr.success('Saved successfully', 'Success', {
											timeOut: 3000,
											tapToDismiss: true,
											closeButton: true
										});
										this.gotoList();
									}, error: (error) => {
										this.showLoader = false;
										this.toastr.error('Something went wrong', 'Error', {
											timeOut: 3000,
											tapToDismiss: true,
											closeButton: true
										});
									},
								});
							} else {
								this.showLoader = false;
								this.toastr.success('Saved successfully', 'Success', {
									timeOut: 3000,
									tapToDismiss: true,
									closeButton: true
								});
								this.gotoList();
							} */
							this.showLoader = false;
							this.toastr.success('Saved successfully', 'Success', {
								timeOut: 3000,
								tapToDismiss: true,
								closeButton: true
							});
							this.checkForQuestionnaire();
						}, error: (error) => {
							this.showLoader = false;
							this.toastr.error('Something went wrong', 'Error', {
								timeOut: 3000,
								tapToDismiss: true,
								closeButton: true
							});
						},
					});
				} else {
					/* if (this.isFollowupClosed) {
						let payload4: any = {
							id: this.uId,
							closure_notes: null,
							status4_id: null,
							status_id: 1,
						}
						this.apiService.updateCaseDetails(payload4).subscribe({
							next: (data: any) => {
								this.showLoader = false;
								this.toastr.success('Saved successfully', 'Success', {
									timeOut: 3000,
									tapToDismiss: true,
									closeButton: true
								});
								this.gotoList();
							}, error: (error) => {
								this.showLoader = false;
								this.toastr.error('Something went wrong', 'Error', {
									timeOut: 3000,
									tapToDismiss: true,
									closeButton: true
								});
							},
						});
					} else {
						this.showLoader = false;
						this.toastr.success('Saved successfully', 'Success', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
						this.gotoList();
					} */
					this.showLoader = false;
					this.toastr.success('Saved successfully', 'Success', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
					this.checkForQuestionnaire();
				}
			}, error: (error) => {
				this.showLoader = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	clearOTPForm() {
		this.otpForm.reset();
		this.showOTP = false;
		this.otpMailId = "";
		this.f1["reason"].enable();
		this.f1["otp"].setValidators(null);
		this.f1["otp"].updateValueAndValidity();
	}

	otpVerification() {
		this.clearOTPForm();
		$("#otpModalFollowup").modal("show");
	}

	showOTPFormError(field: string) {
		if (this.f1[field].invalid && (this.otpFormSubmitted || this.f1[field].touched || this.f1[field].dirty)) {
			return true;
		}
		return false;
	}

	clearCustomErrorOTP() {
		Object.keys(this.f1).forEach(key => {
			if (this.f1[key].hasError('incorrect')) {
				try {
					delete this.f1[key].errors?.incorrect;
					this.f1[key].updateValueAndValidity();
				} catch (error) {
				}
			}
		});
		this.customErrorOTP = {};
	}

	getOTPPayload() {
		return {
			"case_id": this.parent.caseDetails.id,
			"type": "followup",
			"field": "date",
			"reason": this.f1["reason"].value,
			"followup": [
				{
					"id": this.followUpDetails.id,
					"date": this.apiService.getDateStringFromDateDMY(this.f.follow_up_date?.value) || null
				}
			]
		}
	}

	getOTP() {
		this.otpFormSubmitted = true;
		this.clearCustomErrorOTP();
		if (this.otpForm.invalid) {
			this.toastr.error('Please check required parameters', 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		const payload = this.getOTPPayload();
		this.otpFormLoader = true;
		this.apiService.getOTP(payload).subscribe({
			next: (data: any) => {
				this.otpFormLoader = false;
				this.showOTP = true;
				this.otpMailId = data;
				this.f1["reason"].disable();
				this.f1["otp"].setValidators([Validators.required]);
				this.f1["otp"].updateValueAndValidity();
				this.otpFormSubmitted = false;
				this.toastr.success('OTP sent successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}, error: (error) => {
				this.otpFormLoader = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	verifyOTP() {
		this.otpFormSubmitted = true;
		this.clearCustomErrorOTP();
		if (this.otpForm.invalid) {
			this.toastr.error('Please check required parameters', 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		const payload = this.getOTPPayload();
		payload["otp"] = this.f1["otp"].value;
		this.otpFormLoader = true;
		this.apiService.verifyOTP(payload).subscribe({
			next: (data: any) => {
				this.otpFormLoader = false;
				this.clearOTPForm();
				this.toastr.success('OTP verified successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				$("#otpModalFollowup").modal("hide");
				this.saveFollowUp_B();
			}, error: (error) => {
				this.otpFormLoader = false;
				this.f1.otp.setErrors({ incorrect: true });
				this.customErrorOTP.otp = "Invalid OTP";
			}
		});
	}

	checkForQuestionnaire() {
		if (this.showClosureFields || this.showCompletedFields) {
			this.getQuestions();
		} else {
			this.gotoList();
		}
	}

	gotoList() {
		/* this.router.navigateByUrl('/refresh', { skipLocationChange: true }).then(() => {
			this.router.navigate(['/app/' + this.apptDetailsPath, this.uId, "follow-up", this.followupId]);
		}); */
		this.router.navigateByUrl('/refresh', { skipLocationChange: true }).then(() => {
			this.router.navigate(['/app/appt-details', 'no', this.uId, this.followupId]);
		});
	}

	getHospitalList() {
		this.apiService.getHospital({}).subscribe({
			next: (data: any) => {
				this.hospitalList = data.data;
			}, error: (error) => {
				this.hospitalList = [];
			},
		});
	}

	getDoctorList() {
		/* let payload: any = {};
		if (this.f.dropoff_hospital_id.value) {
			payload["id"] = this.f.dropoff_hospital_id.value;
		}
		this.apiService.getDoctorList(payload).subscribe({
			next: (data: any) => {
				this.doctorList = [...data.data];
				if (this.f.opd_doctor_id.value) {
					if (!this.doctorList.find((doc) => doc.id == this.f.opd_doctor_id.value)) {
						this.f.opd_doctor_id.setValue(null);
					}
				}
			}, error: (error) => {
				this.doctorList = [];
				this.doctorList = this.doctorList.slice(0);
				this.f.opd_doctor_id.setValue(null);
			},
		}); */
		this.doctorList = this.navbar.filterDoctors(this.f.dropoff_hospital_id.value);
		if (!this.doctorList.find((doc) => doc.id == this.f.opd_doctor_id.value)) {
			this.f.opd_doctor_id.setValue(null);
		}
	}

	apptTypeChanged(calledByUser: boolean) {
		let val = this.f.visit_type_id.value;
		if (val == 1) {
			/* OPD */
			this.showOPDFields = true;
			this.showIPDFields = false;
			this.showPhysiotherapyFields = false;
			this.showTeleConsultsFields = false;
			this.showNonMedicalFields = false;
			this.clearPhysiotherapyFields();
			this.clearIPDFields();
			this.clearTeleConsultsFields();
			this.clearNonMedicalFields();
			if (calledByUser) {
				this.f.is_payment_needed.setValue(true);
			}
		} else if (val == 2) {
			/* IPD */
			this.showOPDFields = false;
			this.showIPDFields = true;
			this.showPhysiotherapyFields = false;
			this.showTeleConsultsFields = false;
			this.showNonMedicalFields = false;
			this.clearOPDFields();
			this.clearPhysiotherapyFields();
			this.clearTeleConsultsFields();
			this.clearNonMedicalFields();
		} else if (val == 3) {
			/* Physiotherapy */
			this.showOPDFields = false;
			this.showIPDFields = false;
			this.showPhysiotherapyFields = true;
			this.showTeleConsultsFields = false;
			this.showNonMedicalFields = false;
			this.clearOPDFields();
			this.clearIPDFields();
			this.clearTeleConsultsFields();
			this.clearNonMedicalFields();

			if (calledByUser) {
				this.f.is_payment_needed.setValue(true);
			}
		} else if (val == 4) {
			/* Tele-Consult */
			this.showOPDFields = false;
			this.showIPDFields = false;
			this.showPhysiotherapyFields = false;
			this.showTeleConsultsFields = true;
			this.showNonMedicalFields = false;
			this.clearOPDFields();
			this.clearIPDFields();
			this.clearPhysiotherapyFields();
			this.clearNonMedicalFields();

			this.clearNonTeleConsultsFields();

			if (calledByUser) {
				this.f.is_payment_needed.setValue(true);
			}
		} else if (val == 5) {
			/* Non Medical */
			this.showOPDFields = false;
			this.showIPDFields = false;
			this.showPhysiotherapyFields = false;
			this.showTeleConsultsFields = false;
			this.showNonMedicalFields = true;
			this.clearOPDFields();
			this.clearIPDFields();
			this.clearPhysiotherapyFields();
			this.clearTeleConsultsFields();

			this.clearNonNonMedicalFields();
		} else {
			this.showOPDFields = false;
			this.showIPDFields = false;
			this.showPhysiotherapyFields = false;
			this.showTeleConsultsFields = false;
			this.showNonMedicalFields = false;
			this.clearOPDFields();
			this.clearIPDFields();
			this.clearPhysiotherapyFields();
			this.clearTeleConsultsFields();
			this.clearNonMedicalFields();
		}
	}

	clearOPDFields() {
		this.f.lab_test.setValue(null);
	}

	clearIPDFields() {
		this.f.hospitalization_status_id.setValue(null);
		this.f.admission_date.setValue(null);
		this.f.admission_date.clearValidators();
		this.f.admission_date.updateValueAndValidity();
		this.f.surgery_status_id.setValue(null);
		this.f.actual_surgery_date.setValue(null);
		this.f.actual_discharge_date.setValue(null);
		this.f.actual_discharge_date.clearValidators();
		this.f.actual_discharge_date.updateValueAndValidity();
		this.hospitalizationChanged();
		this.surgeryChanged();
	}

	clearPhysiotherapyFields() {
		this.f.physiotherapy_percentage.setValue(null);
		this.f.physiotherapy_notes.setValue(null);
		/* this.f.physiotherapy_date.setValue(null);
		this.f.physiotherapy_end_date.setValue(null);
		this.f.physiotherapy_session_counts.setValue(null); */
	}

	clearTeleConsultsFields() {
		this.f.amount.setValue(0);
	}

	clearNonMedicalFields() {
		this.f.is_handover.setValue(false);
		this.f.medicine_supply.setValue(null);
		this.f.is_referral_added.setValue(false);
		this.f.referral_file.setValue(null);
		this.reffFlagChanged();
	}

	clearNonTeleConsultsFields() {
		this.f.travel_needed.setValue(0);
		this.f.dropoff_hospital_id.setValue(null);
	}

	clearNonNonMedicalFields() {
		/* this.f.disability_status_id.setValue(null);
		this.f.disability_per.setValue(null);
		this.f.disability_notes.setValue(null); */
		this.f.dropoff_hospital_id.setValue(null);
		this.f.opd_doctor_id.setValue(null);
		/* this.f.is_specialist_consulted.setValue(false); */
		this.f.is_payment_needed.setValue(false);
		this.f.travel_needed.setValue(0);
		this.f.medical_prescription.setValue(false);
		this.f.lab_test.setValue(null);
		this.f.physiotherapy_percentage.setValue(null);
		this.f.physiotherapy_notes.setValue(null);
		this.f.hospitalization_status_id.setValue(null);
		this.f.admission_date.setValue(null);
		this.f.admission_date.clearValidators();
		this.f.admission_date.updateValueAndValidity();
		this.f.actual_discharge_date.setValue(null);
		this.f.actual_discharge_date.clearValidators();
		this.f.actual_discharge_date.updateValueAndValidity();
		this.f.is_ambulance_needed.setValue(null);
		this.f.expected_days.setValue(null);
		this.f.surgery_status_id.setValue(null);
		this.f.actual_surgery_date.setValue(null);
	}

	reffFlagChanged() {
		let val = this.f.is_referral_added.value;
		if (val) {
			this.showReferralFields = true;
		} else {
			this.showReferralFields = false;
			this.clearReffFields();
		}
	}

	clearReffFields() {
		this.f.referral_file.setValue(null);
	}

	hospitalizationChanged() {
		let val = this.f.hospitalization_status_id.value;
		if (val == 4) {
			/* Admitted */
			this.showAdmittedFields = true;
			this.showPreAdmittedFields = false;
			this.showDischargedFields = false;
			this.showDayCareFields = false;
			this.clearPreAdmittedFields();
			this.clearDischargedFields();
			this.clearDayCareFields();
			this.f.admission_date.setValidators([Validators.required]);
			this.f.admission_date.updateValueAndValidity();
		} else if (val == 28) {
			/* Daycare Procedure */
			this.showAdmittedFields = false;
			this.showPreAdmittedFields = false;
			this.showDischargedFields = false;
			this.showDayCareFields = true;
			this.clearAdmittedFields();
			this.clearPreAdmittedFields();
			this.clearDischargedFields();

			this.clearNonDischargedFields();

			if (!this.f.actual_surgery_date.value) {
				this.f.actual_surgery_date.setValue(new Date());
			}
		} else if (val == 6) {
			/* Preadmission */
			this.showAdmittedFields = false;
			this.showPreAdmittedFields = true;
			this.showDischargedFields = false;
			this.showDayCareFields = false;
			this.clearAdmittedFields();
			this.clearDayCareFields();
			this.clearDischargedFields();
		} else if (val == 5) {
			/* Discharged */
			this.showAdmittedFields = false;
			this.showPreAdmittedFields = false;
			this.showDischargedFields = true;
			this.showDayCareFields = false;
			this.clearAdmittedFields();
			this.clearDayCareFields();
			this.clearPreAdmittedFields();

			this.clearNonDischargedFields();
			this.f.actual_discharge_date.setValidators([Validators.required]);
			this.f.actual_discharge_date.updateValueAndValidity();
		} else {
			this.showAdmittedFields = false;
			this.showPreAdmittedFields = false;
			this.showDischargedFields = false;
			this.showDayCareFields = false;
			this.clearAdmittedFields();
			this.clearPreAdmittedFields();
			this.clearDischargedFields();
			this.clearDayCareFields();
		}
	}


	clearAdmittedFields() {
	}

	clearDayCareFields() {
	}

	clearPreAdmittedFields() {
	}

	clearDischargedFields() {
		this.f.is_ambulance_needed.setValue(false);
		this.f.actual_discharge_date.setValue(null);
		this.f.actual_discharge_date.clearValidators();
		this.f.actual_discharge_date.updateValueAndValidity();
	}

	clearNonDischargedFields() {
		this.f.surgery_status_id.setValue(null);
		this.f.actual_surgery_date.setValue(null);
		this.f.expected_days.setValue(null);
		this.f.admission_date.setValue(null);
		this.f.admission_date.clearValidators();
		this.f.admission_date.updateValueAndValidity();
	}

	surgeryChanged() {
		let val = this.f.surgery_status_id.value;
		if (val == 7) {
			/* Yes */
			this.showSurgeryYesFields = true;
			this.showSurgeryNoFields = false;
			this.clearSurgeryNoFields();
			this.f.actual_surgery_date.setValidators([Validators.required]);
			this.f.actual_surgery_date.updateValueAndValidity();
		} else if (val == 8) {
			/* No */
			this.showSurgeryYesFields = false;
			this.showSurgeryNoFields = true;
			this.clearSurgeryYesFields();
		} else {
			this.showSurgeryYesFields = false;
			this.showSurgeryNoFields = false;
			this.clearSurgeryYesFields();
			this.clearSurgeryNoFields();
		}
	}

	clearSurgeryYesFields() {
		/* this.f.actual_surgery_date.setValue(null); */
		this.f.actual_surgery_date.clearValidators();
		this.f.actual_surgery_date.updateValueAndValidity();
	}

	clearSurgeryNoFields() { }

	followupStatusChanged(isChangedByUser: boolean) {
		let val = this.f.follow_up_status_id.value;
		if (val === 1) {
			this.showInProgressFields = true;
			this.showClosureFields = false;
			this.showCompletedFields = false;
			this.clearClosureFields();
			this.clearCompletedFields();
		} else if (val === 2) {
			this.showInProgressFields = false;
			this.showClosureFields = false;
			if (isChangedByUser) {
				this.showCompletedFields = true;
				/* this.f.next_follow_up_date.setValidators([Validators.required]);
				this.f.next_follow_up_date.setValue(addDays(this.f.follow_up_date.value, 5));
				this.f.next_follow_up_date.updateValueAndValidity();
				this.f.next_visit_type_id.setValidators([Validators.required]);
				this.f.next_visit_type_id.setValue(4);
				this.f.next_visit_type_id.updateValueAndValidity(); */
			}
			this.clearClosureFields();
			this.clearInProgressFields();
			/* this.f.follow_up_date.disable(); */
		} else if (val === 3) {
			this.showInProgressFields = false;
			this.showClosureFields = true;
			this.showCompletedFields = false;
			/* this.f.status4_id.setValidators([Validators.required]);
			this.f.status4_id.updateValueAndValidity();
			this.f.closure_notes.setValidators([Validators.required]);
			this.f.closure_notes.updateValueAndValidity(); */
			this.clearCompletedFields();
			this.clearInProgressFields();
			/* if (this.parent.caseDetails.closure_notes) {
				this.f.closure_notes.setValue(this.parent.caseDetails.closure_notes);
			}
			if (this.parent.caseDetails.status4) {
				this.f.status4_id.setValue(this.parent.caseDetails.status4);
			} */
		} else {
			this.showInProgressFields = false;
			this.showClosureFields = false;
			this.showCompletedFields = false;
			this.clearClosureFields();
			this.clearCompletedFields();
			this.clearInProgressFields();
		}
	}

	clearInProgressFields() { }

	clearClosureFields() {
		/* this.f.fitness_status_id.setValue(null);
		this.f.fitness_status_id.clearValidators();
		this.f.fitness_status_id.updateValueAndValidity(); */

		/* this.f.status4_id.setValue(null);
		this.f.status4_id.clearValidators();
		this.f.status4_id.updateValueAndValidity();
		this.f.closure_notes.setValue(null);
		this.f.closure_notes.clearValidators();
		this.f.closure_notes.updateValueAndValidity(); */
	}

	clearCompletedFields() {
		this.f.next_follow_up_date.setValue(null);
		this.f.next_follow_up_date.clearValidators();
		this.f.next_follow_up_date.updateValueAndValidity();
		this.f.next_visit_type_id.setValue(null);
		this.f.next_visit_type_id.clearValidators();
		this.f.next_visit_type_id.updateValueAndValidity();
	}

	getLabTest() {
		this.apiService.getLabTest({}).subscribe({
			next: (data: any) => {
				this.labTestList = data.data;
			}, error: (error) => {
				this.labTestList = [];
			},
		});
	}

	/* getFitnesStatus() {
		this.apiService.getFitnesStatus().subscribe({
			next: (data: any) => {
				this.fitnessStatusList = data;
			}, error: (error) => {
				this.fitnessStatusList = [];
			},
		});
	} */

	getFolloupBills(): void {
		this.pageLoading2 = true;
		this.apiService.getFolloupBills({ id: this.followUpDetails.id }).subscribe({
			next: (data: any) => {
				data.data.map((bill: any) => {
					bill.files = bill.files === null ? [] : bill.files;
					bill.gpay_files = bill.gpay_files === null ? [] : bill.gpay_files;
					bill.qrcode_files = bill.qrcode_files === null ? [] : bill.qrcode_files;
					return bill
				});
				this.pageLoading2 = false;
				this.followUpBillsData = data.data;
				try {
					this.parent.autoReadyToBill();
				} catch (error) { }
			}, error: (error) => {
				this.pageLoading2 = false;
				this.followUpBillsData = [];
			}
		})
	}

	openBillModal() {
		let billingDetailsForEdit: any[] = JSON.parse(JSON.stringify(this.followUpBillsData));
		billingDetailsForEdit.forEach((bill: any) => {
			bill.date = this.apiService.getDateFromDateString(bill.date);
		});
		this.billingDetailsForEdit = billingDetailsForEdit;
		$("#billingModalFollowup").modal("show");
	}

	closeBillingModal() {
		$("#billingModalFollowup").modal("hide");
	}

	saveBilling() {
		let billing: any[] = [];
		let allowedDate = addDays(new Date(), 1);
		let len = this.billingDetailsForEdit.length;
		for (let i = 0; i < len; i++) {
			let bill = this.billingDetailsForEdit[i];
			if (bill.date && isBefore(allowedDate, bill.date)) {
				this.toastr.error("Future date is not allowed", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				return;
			}
			if (!bill.notes) {
				this.toastr.error("Please enter notes", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				return;
			}
			if (bill.amount === "" || bill.amount == null || bill.amount <= 0) {
				this.toastr.error("Please enter valid amount", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				return;
			}
			billing.push({
				"id": bill.id || "",
				"case_id": this.parent.caseDetails.id,
				"followup_id": this.followUpDetails.id,
				"category_id": bill.category,
				"date": this.apiService.getDateStringFromDate(bill.date),
				"notes": bill.notes,
				"amount": bill.amount,
				"is_paid": bill.is_paid,
				"is_approved": bill.is_approved,
				"reimbursement": bill.reimbursement,
				"files": bill.files,
				"gpay_files": bill.gpay_files,
				"qrcode_files": bill.qrcode_files,
			})
		};
		this.saveBillLoader = true;
		this.apiService.sendFollowUpBills(billing).subscribe({
			next: (data: any) => {
				this.saveBillLoader = false;
				this.toastr.success("Billing saved successfully.", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.closeBillingModal();
				this.getFolloupBills();
				this.parent.getFolloupBillsByCase();
			}, error: (error: any) => {
				this.saveBillLoader = false;
				this.toastr.error("Something went wrong", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	saveBillLoaderSingle: any = null;
	saveSingleBilling(i: number) {
		let billing: any[] = [];
		let allowedDate = addDays(new Date(), 1);
		let bill = this.billingDetailsForEdit[i];
		if (bill.date && isBefore(allowedDate, bill.date)) {
			this.toastr.error("Future date is not allowed", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		if (!bill.notes) {
			this.toastr.error("Please enter notes", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		if (bill.amount === "" || bill.amount == null || bill.amount <= 0) {
			this.toastr.error("Please enter valid amount", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		billing.push({
			"id": bill.id || "",
			"case_id": this.parent.caseDetails.id,
			"followup_id": this.followUpDetails.id,
			"category_id": bill.category,
			"date": this.apiService.getDateStringFromDate(bill.date),
			"notes": bill.notes,
			"amount": bill.amount,
			"is_paid": bill.is_paid,
			"is_approved": bill.is_approved,
			"reimbursement": bill.reimbursement,
			"files": bill.files,
			"gpay_files": bill.gpay_files,
			"qrcode_files": bill.qrcode_files,
		})
		this.saveBillLoaderSingle = i;
		this.apiService.sendFollowUpBills(billing).subscribe({
			next: (data: any) => {
				this.saveBillLoaderSingle = null;
				this.toastr.success("Billing saved successfully.", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.closeBillingModal();
				this.getFolloupBills();
				this.parent.getFolloupBillsByCase();
			}, error: (error: any) => {
				this.saveBillLoaderSingle = null;
				this.toastr.error("Something went wrong", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	addBillingDetails() {
		this.billingDetailsForEdit.push({
			"id": "",
			"case_id": this.parent.caseDetails.id,
			"followup_id": this.followUpDetails.id,
			"category_id": null,
			"date": new Date(),
			"notes": null,
			"amount": 0,
			"is_paid": false,
			"is_approved": false,
			"reimbursement": false,
			"files": [],
			"gpay_files": [],
			"qrcode_files": [],
		});
	}

	removeBillingDetails(index: number) {
		if (this.billingDetailsForEdit[index].used_in_invoice) {
			return;
		}
		if (this.billingDetailsForEdit[index].id) {
			Swal.fire({
				title: 'Warning',
				text: 'Are you sure you want to delete record?',
				icon: 'warning',
				showCancelButton: true,
				showConfirmButton: true,
				confirmButtonText: 'Yes, delete it!',
				cancelButtonText: 'Cancel',
				confirmButtonColor: '#f23022'
			}).then((result) => {
				if (result.value) {
					this.apiService.deleteFollowUpBills({ id: this.billingDetailsForEdit[index].enc_id }).subscribe({
						next: data => {
							Swal.fire('Success', 'Record Deleted Successfully.', 'success');
							this.billingDetailsForEdit.splice(index, 1);
							this.getBillingTotal();
							this.getFolloupBills();
						}, error: (error) => {
							if (error.status == 401) { return }
							Swal.fire('Error', 'Something went wrong.', 'error');
						}
					});
				}
			})
		} else {
			this.billingDetailsForEdit.splice(index, 1);
			this.getBillingTotal();
		}
	}

	getBillingTotal() {
		try {
			let amount = 0;
			this.billingDetailsForEdit.forEach((bill: any) => {
				if (!isNaN(bill.amount)) {
					amount += bill.amount;
				}
			});
			this.amount = amount;
		} catch (error) {
			this.amount = 0;
		}
	}


	allowedBillFiles = allowedBillFiles;
	billFileUploaded(filepath: any, index: number) {
		if (!this.billingDetailsForEdit[index].files) {
			this.billingDetailsForEdit[index].files = [];
		}
		this.billingDetailsForEdit[index].files.push(filepath);
	}

	amountFetched(amountData: any, index: number) {
		this.billingDetailsForEdit[index].amount = amountData;
		this.toastr.success("Fetched " + amountData, 'Success', {
			timeOut: 3000,
			tapToDismiss: true,
			closeButton: true
		});
	}

	deleteBillFile(name: string, i: number, j: number) {
		if (this.billingDetailsForEdit[i].used_in_invoice) {
			return;
		}
		Swal.fire({
			title: 'Warning',
			text: 'Are you sure you want to delete file?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#f23022'
		}).then((result) => {
			if (result.value) {
				let billObj = JSON.parse(JSON.stringify(this.billingDetailsForEdit[i]));
				billObj.files.splice(j, 1);
				let payload = {
					files: billObj.files,
					id: billObj.id,
					file: name
				};
				this.apiService.billFileDelete(payload).subscribe({
					next: data => {
						Swal.fire('Success', 'File Deleted Successfully.', 'success');
						this.billingDetailsForEdit[i].files.splice(j, 1);
					}, error: (error) => {
						if (error.status == 401) { return }
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
				/* this.apiService.fileDelete({ file: name }).subscribe({
					next: data => {
						Swal.fire('Success', 'File Deleted Successfully.', 'success');
						this.billingDetailsForEdit[i].files.splice(j, 1);
					}, error: (error) => {
						if (error.status == 401) { return }
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				}); */
			}
		})
	}

	allowedBillGPayFiles = allowedBillGPayFiles;
	gpayFileUploaded(filepath: any, index: number) {
		if (!this.billingDetailsForEdit[index].gpay_files) {
			this.billingDetailsForEdit[index].gpay_files = [];
		}
		this.billingDetailsForEdit[index].gpay_files.push(filepath);
	}

	deleteBillGpayFile(name: string, i: number, j: number) {
		if (this.billingDetailsForEdit[i].used_in_invoice) {
			return;
		}
		Swal.fire({
			title: 'Warning',
			text: 'Are you sure you want to delete file?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#f23022'
		}).then((result) => {
			if (result.value) {
				let billObj = JSON.parse(JSON.stringify(this.billingDetailsForEdit[i]));
				billObj.gpay_files.splice(j, 1);
				let payload = {
					gpay_files: billObj.gpay_files,
					id: billObj.id,
					file: name
				};
				this.apiService.billFileDelete(payload).subscribe({
					next: data => {
						Swal.fire('Success', 'File Deleted Successfully.', 'success');
						this.billingDetailsForEdit[i].gpay_files.splice(j, 1);
					}, error: (error) => {
						if (error.status == 401) { return }
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
				/* this.apiService.fileDelete({ file: name }).subscribe({
					next: data => {
						Swal.fire('Success', 'File Deleted Successfully.', 'success');
						this.billingDetailsForEdit[i].gpay_files.splice(j, 1);
					}, error: (error) => {
						if (error.status == 401) { return }
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				}); */
			}
		})
	}

	allowedBillQRFiles = allowedBillQRFiles;
	qrFileUploaded(filepath: any, index: number) {
		if (!this.billingDetailsForEdit[index].qrcode_files) {
			this.billingDetailsForEdit[index].qrcode_files = [];
		}
		this.billingDetailsForEdit[index].qrcode_files.push(filepath);
	}

	deleteBillQRFile(name: string, i: number, j: number) {
		if (this.billingDetailsForEdit[i].used_in_invoice) {
			return;
		}
		Swal.fire({
			title: 'Warning',
			text: 'Are you sure you want to delete file?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#f23022'
		}).then((result) => {
			if (result.value) {
				let billObj = JSON.parse(JSON.stringify(this.billingDetailsForEdit[i]));
				billObj.qrcode_files.splice(j, 1);
				let payload = {
					qrcode_files: billObj.qrcode_files,
					id: billObj.id,
					file: name
				};
				this.apiService.billFileDelete(payload).subscribe({
					next: data => {
						Swal.fire('Success', 'File Deleted Successfully.', 'success');
						this.billingDetailsForEdit[i].qrcode_files.splice(j, 1);
					}, error: (error) => {
						if (error.status == 401) { return }
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
				/* this.apiService.fileDelete({ file: name }).subscribe({
					next: data => {
						Swal.fire('Success', 'File Deleted Successfully.', 'success');
						this.billingDetailsForEdit[i].qrcode_files.splice(j, 1);
					}, error: (error) => {
						if (error.status == 401) { return }
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				}); */
			}
		})
	}

	getFileName(filepath: string) {
		try {
			return filepath.split("/").pop() || "";
		} catch (error) {
			return filepath;
		}
	}

	getFollowUpFiles() {
		this.pageLoading3 = true;
		this.apiService.getFollowUpFiles({ id: this.followUpDetails.id }).subscribe({
			next: (data: any) => {
				data.data.map((bill: any) => {
					bill.file_url = bill.file_url === null ? [] : bill.file_url;
					return bill
				});
				this.pageLoading3 = false;
				this.followupFiles = data.data;
				try {
					this.parent.autoReadyToBill();
				} catch (error) { }
			}, error: (error) => {
				this.pageLoading3 = false;
				this.followupFiles = [];
			}
		})
	}

	openFileModal() {
		let followupFilesForEdit: any[] = JSON.parse(JSON.stringify(this.followupFiles));
		this.followupFilesForEdit = followupFilesForEdit;
		$("#fileModal").modal("show");
	}

	allowedFiles = allowedFiles;
	followUpFileUploaded(data: any, index: number) {
		if (!this.followupFilesForEdit[index].file_url) {
			this.followupFilesForEdit[index].file_url = [];
		}
		this.followupFilesForEdit[index].file_url.push(data);
	}

	deleteFollowupFile(name: string, i: number, j: number) {
		Swal.fire({
			title: 'Warning',
			text: 'Are you sure you want to delete file?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#f23022'
		}).then((result) => {
			if (result.value) {
				this.apiService.fileDelete({ file: name }).subscribe({
					next: data => {
						Swal.fire('Success', 'File Deleted Successfully.', 'success');
						this.followupFilesForEdit[i].file_url.splice(j, 1);
					}, error: (error) => {
						if (error.status == 401) { return }
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
			}
		})
	}

	closeFileModal() {
		$("#fileModal").modal("hide");
	}

	saveFileLoader = false;
	saveFiles() {
		let files: any[] = [];
		let len = this.followupFilesForEdit.length;
		for (let i = 0; i < len; i++) {
			let bill = this.followupFilesForEdit[i];
			if (!bill.file_name) {
				this.toastr.error("Please enter notes", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				return;
			}
			files.push({
				"id": bill.id || "",
				"followup_id": this.followUpDetails.id,
				"file_name": bill.file_name,
				"file_url": bill.file_url,
				"is_additional_file": false
			})
		};
		this.saveFileLoader = true;
		this.apiService.saveFollowUpFiles(files).subscribe({
			next: (data: any) => {
				this.saveFileLoader = false;
				this.toastr.success("Files saved successfully.", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.closeFileModal();
				/* this.getFollowUpFiles(); */
				this.apiService.sendFollowUpFilesRefreshEvent();
			}, error: (error: any) => {
				this.saveFileLoader = false;
				this.toastr.error("Something went wrong", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	addFiles() {
		this.followupFilesForEdit.push({
			"id": "",
			"followup_id": this.followUpDetails.id,
			"file_name": null,
			"file_url": []
		});
	}

	removeFileDetails(index: number) {
		if (this.followupFilesForEdit[index].id) {
			Swal.fire({
				title: 'Warning',
				text: 'Are you sure you want to delete record?',
				icon: 'warning',
				showCancelButton: true,
				showConfirmButton: true,
				confirmButtonText: 'Yes, delete it!',
				cancelButtonText: 'Cancel',
				confirmButtonColor: '#f23022'
			}).then((result) => {
				if (result.value) {
					this.apiService.deleteFollowUpFiles({ id: this.followupFilesForEdit[index].enc_id }).subscribe({
						next: data => {
							Swal.fire('Success', 'Record Deleted Successfully.', 'success');
							this.followupFilesForEdit.splice(index, 1);
							this.getFollowUpFiles();
						}, error: (error) => {
							if (error.status == 401) { return }
							Swal.fire('Error', 'Something went wrong.', 'error');
						}
					});
				}
			})
		} else {
			this.followupFilesForEdit.splice(index, 1);
		}
	}

	//////////////////////////////////////////////
	getFollowUpAdditionalFiles() {
		this.pageLoading5 = true;
		this.apiService.getFollowUpAdditionalFiles({ id: this.followUpDetails.id }).subscribe({
			next: (data: any) => {
				data.data.map((bill: any) => {
					bill.file_url = bill.file_url === null ? [] : bill.file_url;
					return bill
				});
				this.pageLoading5 = false;
				this.followupAdditionalFiles = data.data;
				try {
					this.parent.autoReadyToBill();
				} catch (error) { }
			}, error: (error) => {
				this.pageLoading5 = false;
				this.followupAdditionalFiles = [];
			}
		})
	}

	openAdditionalFileModal() {
		let followupAdditionalFilesForEdit: any[] = JSON.parse(JSON.stringify(this.followupAdditionalFiles));
		this.followupAdditionalFilesForEdit = followupAdditionalFilesForEdit;
		$("#additionalFileModal").modal("show");
	}

	allowedAdditionalFiles = allowedAdditionalFiles;
	followUpAdditionalFileUploaded(data: any, index: number) {
		if (!this.followupAdditionalFilesForEdit[index].file_url) {
			this.followupAdditionalFilesForEdit[index].file_url = [];
		}
		this.followupAdditionalFilesForEdit[index].file_url.push(data);
	}

	deleteFollowupAdditionalFile(name: string, i: number, j: number) {
		Swal.fire({
			title: 'Warning',
			text: 'Are you sure you want to delete file?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#f23022'
		}).then((result) => {
			if (result.value) {
				this.apiService.fileDelete({ file: name }).subscribe({
					next: data => {
						Swal.fire('Success', 'File Deleted Successfully.', 'success');
						this.followupAdditionalFilesForEdit[i].file_url.splice(j, 1);
					}, error: (error) => {
						if (error.status == 401) { return }
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
			}
		})
	}

	closeAdditionalFileModal() {
		$("#additionalFileModal").modal("hide");
	}

	saveAdditionalFileLoader = false;
	saveAdditionalFiles() {
		let files: any[] = [];
		let len = this.followupAdditionalFilesForEdit.length;
		for (let i = 0; i < len; i++) {
			let bill = this.followupAdditionalFilesForEdit[i];
			if (!bill.file_name) {
				this.toastr.error("Please enter notes", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				return;
			}
			files.push({
				"id": bill.id || "",
				"followup_id": this.followUpDetails.id,
				"file_name": bill.file_name,
				"file_url": bill.file_url,
				"is_additional_file": true
			})
		};
		this.saveAdditionalFileLoader = true;
		this.apiService.saveFollowUpFiles(files).subscribe({
			next: (data: any) => {
				this.saveAdditionalFileLoader = false;
				this.toastr.success("Files saved successfully.", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.closeAdditionalFileModal();
				this.apiService.sendFollowUpFilesRefreshEvent();
			}, error: (error: any) => {
				this.saveFileLoader = false;
				this.toastr.error("Something went wrong", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	addAdditionalFiles() {
		this.followupAdditionalFilesForEdit.push({
			"id": "",
			"followup_id": this.followUpDetails.id,
			"file_name": null,
			"file_url": []
		});
	}

	removeAdditionalFileDetails(index: number) {
		if (this.followupAdditionalFilesForEdit[index].id) {
			Swal.fire({
				title: 'Warning',
				text: 'Are you sure you want to delete record?',
				icon: 'warning',
				showCancelButton: true,
				showConfirmButton: true,
				confirmButtonText: 'Yes, delete it!',
				cancelButtonText: 'Cancel',
				confirmButtonColor: '#f23022'
			}).then((result) => {
				if (result.value) {
					this.apiService.deleteFollowUpFiles({ id: this.followupAdditionalFilesForEdit[index].enc_id }).subscribe({
						next: data => {
							Swal.fire('Success', 'Record Deleted Successfully.', 'success');
							this.followupAdditionalFilesForEdit.splice(index, 1);
							this.getFollowUpAdditionalFiles();
						}, error: (error) => {
							if (error.status == 401) { return }
							Swal.fire('Error', 'Something went wrong.', 'error');
						}
					});
				}
			})
		} else {
			this.followupAdditionalFilesForEdit.splice(index, 1);
		}
	}
	//////////////////////////////////////////////

	openNewFollowupModal(isHandover: boolean) {
		this.f2.new_follow_up_date.setValue(this.follow_up_date_original);
		if (isHandover) {
			this.f2.new_visit_type_id.setValue(5);
			this.f2.new_visit_type_id.disable();
		} else {
			this.f2.new_visit_type_id.setValue(null);
			this.f2.new_visit_type_id.enable();
		}
		$("#newFollowupModal").modal("show");
	}

	createNewFollowup() {
		this.flwupFormSubmitted = true;
		this.clearCustomErrorNewFlwup();
		if (this.newFollowupForm.invalid) {
			this.toastr.info("Please check required fields", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		if (
			isBefore(this.f2.new_follow_up_date.value, this.apiService.getDateFromDateString(this.parent.caseDetails.start_date))
		) {
			this.f2.new_follow_up_date.setErrors({ incorrect: true });
			this.customErrorNewFlwup.new_follow_up_date = "Cannot be less than case start date";
			this.toastr.info("Followup date cannot be less than case start date", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		if (
			this.getPrevFollowupDate() && isBefore(this.f2.new_follow_up_date.value, this.apiService.getDateFromDateString(this.getPrevFollowupDate()))
		) {
			this.f2.new_follow_up_date.setErrors({ incorrect: true });
			this.customErrorNewFlwup.new_follow_up_date = "Cannot be less than previous followup date";
			this.toastr.info("Followup date cannot be less than previous followup date", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		if (
			isBefore(this.f2.new_follow_up_date.value, this.follow_up_date_original)
		) {
			this.f2.new_follow_up_date.setErrors({ incorrect: true });
			this.customErrorNewFlwup.new_follow_up_date = "Cannot be less than current followup date";
			return;
		}
		let visit_type = this.f2.new_visit_type_id?.value;
		let is_payment_needed = false;
		if (visit_type == 1) {
			/* OPD */
			is_payment_needed = true;
		} else if (visit_type == 3) {
			/* Physiotherapy */
			is_payment_needed = true;
		} else if (visit_type == 4) {
			/* Tele-Consult */
			is_payment_needed = true;
		}
		let payload: any = {
			case_id_id: this.parent.caseDetails.id,
			follow_up_date: this.apiService.getDateStringFromDate(this.f2.new_follow_up_date?.value),
			visit_type_id: visit_type,
			is_payment_needed: is_payment_needed
		}
		if (visit_type == 5) {
			payload["follow_up_status_id"] = 2/* Completed */;
			payload["status3_id"] = 14/* No */;
		}
		this.newFollowupLoader = true;
		this.apiService.createUpdateFollowup(payload).subscribe({
			next: (data: any) => {
				this.newFollowupLoader = false;
				this.toastr.success('Saved successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				$("#newFollowupModal").modal("hide");
				this.gotoList();
			}, error: (error) => {
				this.newFollowupLoader = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	showErrorNewFlwup(field: string) {
		if (this.f2[field].invalid && (this.flwupFormSubmitted || this.f2[field].touched || this.f2[field].dirty)) {
			return true;
		}
		return false;
	}

	clearCustomErrorNewFlwup() {
		Object.keys(this.f2).forEach(key => {
			if (this.f2[key].hasError('incorrect')) {
				try {
					delete this.f2[key].errors?.incorrect;
					this.f2[key].updateValueAndValidity();
				} catch (error) {
				}
			}
		});
		this.customErrorNewFlwup = {};
	}

	allowedReferralFiles = allowedReferralFiles;
	referralFileUploaded(data: any) {
		this.f.referral_file.setValue(data);
		this.formChanged();
	}

	deleteReferralFile() {
		Swal.fire({
			title: 'Warning',
			text: 'Are you sure you want to delete file?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#f23022'
		}).then((result) => {
			if (result.value) {
				this.apiService.fileDelete({ file: this.f.referral_file.value }).subscribe({
					next: data => {
						Swal.fire('Success', 'File Deleted Successfully.', 'success');
						this.f.referral_file.setValue(null);
						this.formChanged();
					}, error: (error) => {
						if (error.status == 401) { return }
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
			}
		})
	}

	formChanged() {
		this.moduleForm.markAsDirty();
	}

	referralDownloadLoader = false;
	getReferralFile() {
		this.referralDownloadLoader = true;
		this.apiService.getReferralFile({ id: this.followUpDetails.id }).subscribe({
			next: res => {
				let data: any = res.body;
				this.referralDownloadLoader = false;
				let blob = new Blob([data], { type: "application/pdf" });
				let fileName = `Referral-${this.parent.caseDetails.case_id}.pdf`;
				FileSaver.saveAs(blob, fileName);
			}, error: (error) => {
				this.referralDownloadLoader = false;
				if (error.status == 401) { return }
				this.toastr.error("Referral file not found", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	rep_sent_loader = false;
	reportSentChanged() {
		const by = this.navbar.user?.first_name + " " + this.navbar.user?.last_name;
		const date = this.apiService.getDateStringFromDate(new Date());
		let payload: any = {
			id: this.followupId,
			followup_report_sent: this.f.followup_report_sent.value,
			followup_report_sent_by: by,
			followup_report_sent_date: date
		}
		this.rep_sent_loader = true;
		this.apiService.saveFollowUpReport(payload).subscribe({
			next: (data: any) => {
				this.rep_sent_loader = false;
				this.toastr.success("Saved successfully.", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.followUpDetails.followup_report_sent_by = by;
				this.followUpDetails.followup_report_sent_date = this.parent.reverseDate(date);
			}, error: (error) => {
				this.rep_sent_loader = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	takeWhile<T>(
		arr: T[],
		predicate: (item: T) => boolean
	): T[] {
		const result: T[] = [];
		let predicateFailed = false;
		for (const item of arr) {
			if (!predicate(item)) {
				predicateFailed = true;
				break;
			}
			result.push(item);
		}
		return predicateFailed ? result : [];
	}


	isHandoverAfterClosed = false;
	checkHandoverAfterClosed() {
		this.pageLoading4 = true;
		this.apiService.getFollowupListAndSingle(this.followupId, this.uId).subscribe({
			next: (resList: any) => {
				this.pageLoading4 = false;
				const followupList: any[] = resList[0].data;
				const followUpDetails: any = resList[1].data;
				const result = this.takeWhile(followupList, item => item.follow_up_status?.id != 3);
				for (let i = 0; i < result.length; i++) {
					if (result[i].id == followUpDetails.id && followUpDetails.visit_type && followUpDetails.visit_type.id == 5) {
						this.isHandoverAfterClosed = true;
					}
				}
			}, error: (error) => {
				this.pageLoading4 = false;
			}
		})
	}

	loadingTreatmentCosts = false;
	treat_costs: any[] = [];
	getTreatmentCosts() {
		this.loadingTreatmentCosts = true;
		this.apiService.getTreatmentCosts({ followup_id: atob(this.followupId) }).subscribe({
			next: (data: any) => {
				this.loadingTreatmentCosts = false;
				this.treat_costs = data.data;
			}, error: (error) => {
				this.loadingTreatmentCosts = false;
				this.treat_costs = [];
			}
		})
	}
}
